import { Helper } from "../../core/util/helper";
import { Grid } from "../../core/components/grid";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Config } from "../../core/config/config";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { ComponentHelper } from "../../core/util/componentHelper";
import { FieldInstance } from "../../core/components/field";
import { CheckBox } from "../../core/components/checkBox";
import UnitSearchBox, { UnitSearchBoxProps } from "../../core/components/unitSearchBox";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { General } from "../../../siteManagement/general";
import { EventType } from "../../../siteManagement/eventManager";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class TravelUnitGrid extends React.Component<any, { data: MainGroupInfo[], dialogOpen: boolean, selected: MainGroupInfo }>{
    private gridOptions: kendo.ui.GridOptions;
    private buttons: Array<ToolBarStandardButton>;
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        open: true,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.setState({ selected: null });
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    const entity = this.state.selected;                   
                    HTTPService.post<JsonResultClass>("ServiceReportSettings/SaveTravelMainGroupInfo", entity).then((result) => {
                        if (result.Code == 0) {
                            this.setState({ selected: null }, this.loadGridData);
                        }
                        else {
                            NotificationHelper.showErrorMessage(result.Message);
                            this.setState({ selected: null });
                        }
                    })
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false, selected: null });
        },
        width: 700
    }
    private defaultUnitId: string;
    private dataSource: any;
    private translations: StringKeyDictionary<string>;

    constructor(props) {
        super(props)
        this.defaultUnitId = props["entity"]["ServiceReportSettings"]["TravelDistanceUnitId"];
        this.initApp();
        this.setEvents();
        this.state = {
            data: [],
            dialogOpen: false,
            selected: null
        }
    }
    private setEvents = () => {
        General.Events.bind(EventType.Custom, (data: { cmd: string, data: any }) => {
            switch (data.cmd) {
                case ("reloadTravelUnits"):
                    this.loadGridData();
                    break;
            }
        });
    }
    private initApp = async () => {
        const result = await Promise.all([
            this.loadGridData(),
            Helper.getTranslations(["WebCRM.Administration.Obergruppe", "WebSMS.GeneralSettings.Units.AllowTravelDistance",
                "Field.Barauslage.Unit", "WebSMS.GeneralSettings.Units.AllowTravelDistance"
            ])
        ])
        this.translations = result[1].Data;
        this.gridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "MainGroup",
                    title: this.translations["WebCRM.Administration.Obergruppe"]
                },
                {
                    field: "AllowTravelDistance",
                    title: this.translations["WebSMS.GeneralSettings.Units.AllowTravelDistance"],
                    template: "# if(data.AllowTravelDistance) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
                },
                {
                    field: "Unit",
                    template: "#if(data.AllowTravelDistance){#<div>#=data.Unit.Value#</div>#}#",
                    title: this.translations["Field.Barauslage.Unit"]
                }
            ]
        }
        this.buttons = [
            {
                caption: Config.translations.editLabel,
                enabled: true,
                type: ToolBarStandardButtonType.EDIT
            }
        ];
        this.setState({})
    }

    private loadGridData = async () => {
        let url = "ServiceReportSettings/GetMainGroupTravelInfos";
        if (!Helper.isNullOrEmpty(this.defaultUnitId)) {
            url += `?defaultUnitId=${this.defaultUnitId}`;
        }
        const result = await HTTPService.get<JsonResultClass<MainGroupInfo[]>>(url);
        if (result.Code == 0) {
            this.setState({ data: result.Data })
        } else {
            NotificationHelper.showErrorMessage(result.Message);
            this.setState({ data: [] })
        }
    }

    private createGrid = () => {
        return (
            <Grid
                options={this.gridOptions}
                id="travelUnits"
                standardButtons={this.buttons}
                data={this.state.data}
                onClickStandardButton={(_, dataItem) => { this.openDialog(dataItem) }}
            />
        );
    }

    private openDialog = (dataItem) => {
        this.setState({ dialogOpen: true, selected: JSON.parse(JSON.stringify(dataItem)) })
    }

    private createDialog = () => {
        return (
            <>
                <Dialog {...this.dialogProps}>
                    {this.createCheckBox()}
                    {Helper.hasValue(this.state.selected) && this.state.selected.AllowTravelDistance ? this.createUnitBox() : null}
                </Dialog>
            </>
        );
    }

    private createCheckBox = () => {
        const props = this.factory.getDefaultCheckBoxProps();
        props.value = this.state.selected.AllowTravelDistance;
        props.onChange = (_, value: boolean) => {
            const entity = this.state.selected;
            entity["AllowTravelDistance"] = value;
            this.setState({ selected: entity })
        }
        return (
            <FieldInstance label={this.translations["WebSMS.GeneralSettings.Units.AllowTravelDistance"]}>
                <CheckBox {...props}/>
            </FieldInstance>
        )
    }

    private createUnitBox = () => {
        const props: UnitSearchBoxProps = {
            field: {
                identifier: "length",
                type: "",
                model: ""
            },
            value: this.state.selected.Unit.Key,
            context: null,
            disabled: false,
            onChange: (_, value, dataItem) => {
                const entity = this.state.selected;
                if (!Helper.isNullOrEmpty(value)) {
                    entity.Unit = {
                        Key: value,
                        Value: dataItem["Name"]
                    }
                } else {
                    entity.Unit = {
                        Key: null,
                        Value: null
                    }
                }
                this.setState({ selected: entity })
            },
            onDataLoaded: (dataSource) => {
                this.dataSource = dataSource;                
            },
            required: false
        }


        return (
            <FieldInstance label={this.translations["Field.Barauslage.Unit"]}>
                <UnitSearchBox {...props}/>
            </FieldInstance>
        );
    }

    componentDidUpdate() {
        const prevDefaultUnitId: string = JSON.parse(JSON.stringify(this.defaultUnitId));
        this.defaultUnitId = this.props["entity"]["ServiceReportSettings"]["TravelDistanceUnitId"];
        if (prevDefaultUnitId !== this.defaultUnitId) {
            this.loadGridData()
        }
    }

    render() {
        const grid = Helper.hasValue(this.gridOptions) ? this.createGrid() : null;
        const dialog = this.state.dialogOpen ? this.createDialog() : null;
        return (
            <>
                {grid}
                {dialog}
            </>
        );
    }
}

interface MainGroupInfo {
    Unit: KeyValuePair<string, string>;
    AllowTravelDistance: boolean;
    OGrNr: number;
}